<template>
  <div
    class="controllers"
    :class="{
      'hide-mobile': hideMobile,
      small: small
    }"
  >
    <button
      type="button"
      class="prev"
      v-if="displayPrev"
      @click="$emit('showPrev')"
      :title="buttonData.prev">
      <svg>
        <use class="not-on-dark" xlink:href="#arrowLeftDarkSvg"></use>
        <use class="on-dark" xlink:href="#arrowLeftSvg"></use>
      </svg>
      {{ buttonData.prev }}
    </button>
    <button
      type="button"
      class="next"
      v-if="displayNext"
      @click="$emit('showNext')"
      :title="buttonData.next">
      <svg>
        <use class="not-on-dark" xlink:href="#arrowRightDarkSvg"></use>
        <use class="on-dark" xlink:href="#arrowRightSvg"></use>
      </svg>
      {{ buttonData.next }}
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'sliderControllers',
  props: ['hideMobile', 'small', 'displayPrev', 'displayNext'],
  computed: {
    ...mapGetters([
      'buttonData'
    ])
  }
}
</script>

<style scoped lang="scss">
  .not-on-dark {
    .dark & {
      display: none;
    }
  }
  .on-dark {
    display: none;
    .dark & {
      display: block;
    }
  }
  .controllers {
    // position: absolute;
    // z-index: 3;
    // top: 50%;
    // transform: translateY(-50%);
    // left: 0;
    // width: 90px;
    // height: 100%;
    button {
      border: 0;
      background-color: transparent;
      box-shadow: none;
      outline: none;
      &:focus {
        outline: none;
      }
      font-size: 0;
      color: transparent;
      &.prev {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
      &.next {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    svg {
      width: $arrow-large;
      height: $arrow-large;
    }
    &.hide-mobile {
      @include mobile {
        display: none;
      }
    }
    &.small {
      svg {
        width: $arrow-small;
        height: $arrow-small;
      }
    }
  }
</style>
